/**
 * card-link.js
 */

import React from 'react';
import { alpha, Box, Button as MuiButton, Tooltip } from '@mui/material';
import Icon from 'components/icon';


export default function CardLink(props) {
  const {
    id,
    iconType,
    number,
    label,
    secondaryLabel,
    onClick,
    isActive,
    tooltip,
    ...rest
  } = props;
  const hasNumber = number !== undefined && number !== null;

  return (
    <Box sx={{ 
      '& .MuiButton-root': {
        fontWeight: 'normal',
        textTransform: 'none',
        width: '100%',
        justifyContent: 'flex-start',

        '& .MuiButton-label': {
          alignItems: 'start',
        },

        '& .MuiSvgIcon-root': {
          fontSize: theme => theme.typography.sizes[6],
        },

        '&.active': {
          backgroundColor: theme => alpha(theme.palette.sys.primaryContainer, 0.5),
        },
      },
    }}>
      <Tooltip 
        arrow 
        title={tooltip || ''}
        placement='top'
      >
        <MuiButton
          {...rest}
          color='grey'
          data-testid={`quick-link-${id}`}
          onClick={onClick}
          className={`${hasNumber ? ' withNumber' : ''}${isActive ? ' active' : ''}`}
        >
          <Box sx={{ 
            display: 'flex',
            alignItems: secondaryLabel ? 'flex-start' : 'center',
            '& > *:not(:last-child)': {
              marginRight: theme => theme.spacing(1),
            },
          }}>
            <Icon type={iconType} sx={{ marginRight: 'spacing.2' }} />
            {hasNumber &&
              <Box 
                sx={{
                  color: theme => theme.palette.primary.colors[5],
                  fontSize: theme => theme.typography.sizes[6],
                  lineHeight: 1,
                  fontWeight: theme => theme.typography.fontWeightBold,
                }}
                data-testtype='quick-link-value'
                children={number}
              />
            }
            <Box 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'left',
                lineHeight: 1.2,
                position: 'relative',
                top: 2,
                '.withNumber &': {
                  top: 0,
                },
              }}
            >
              <div>{label}</div>
              {secondaryLabel &&
                <Box 
                  sx={{
                    mt: '2px',
                    fontSize: theme => theme.typography.sizes[0],
                    color: theme => theme.palette.text.hint,
                    textTransform: 'uppercase',
                  }}
                  children={secondaryLabel}
                />
              }
            </Box>
          </Box>
        </MuiButton>
      </Tooltip>
    </Box>
  );
}